import apiClient from './api/client';        
import ENDPOINTS from './api/endpoints'; 

const inventoryService = {

  async getCategories() {
    const res = await apiClient.get(ENDPOINTS.INVENTORY_CATEGORY.GET_ALL);
    return res?.data?.data || res?.data || [];
  },

  async importFromMenu(payload) {
    const res = await apiClient.post(
      ENDPOINTS.INVENTORY.IMPORT_FROM_MENU,
      payload
    );
    return res?.data || res;
  },
};

export default inventoryService;